import { render, staticRenderFns } from "./ProfileDataChangePassword.vue?vue&type=template&id=41dc18d0&"
import script from "./ProfileDataChangePassword.vue?vue&type=script&lang=js&"
export * from "./ProfileDataChangePassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports